import React, { Fragment, useState, useContext } from 'react';
import styles from './PreviewWrapper.module.css';
import ViewSwitch from '../ViewSwitch/ViewSwitch';
import Logo from '../../../../assets/eb.png';
import { Image } from 'react-bootstrap';
import { WidgetsContext } from '../../../../GlobalContex';

const Placeholder = () => {
  return (
    <div className={`d-flex justify-content-center align-items-center h-100`}>
      <Image className="h-50" src={Logo} />
    </div>
  );
};

const Preview = ({ children }) => {
  const [activeKey, setKey] = useState('desktop');
  const { activeWidget } = useContext(WidgetsContext);

  if (!activeWidget) return <Placeholder />;
  return (
    <Fragment>
      <ViewSwitch {...{ activeKey, setKey }} />
      <div
        className={`d-flex justify-content-center align-items-center ${styles.wrapper} ${
          styles[activeKey] || ''
        }`}
      >
        {children}
      </div>
    </Fragment>
  );
};

export default Preview;
